
import React from "react";

const FuncionariosList = ({ funcionarios }) => {
  return (
    <div className="funcionarios-list">
      {funcionarios.length === 0 ? (
        <div className="funcionarios-list__empty">
          <div className="funcionarios-list__empty-icon" aria-hidden="true">
            <span>♙</span>
          </div>

          <p className="funcionarios-list__empty-title">
            Nenhum profissional cadastrado
          </p>

          <p className="funcionarios-list__empty-description">
            Os profissionais cadastrados aparecerão aqui.
          </p>
        </div>
      ) : (
        <div className="funcionarios-list__container">
          <div className="funcionarios-list__header">
            <span>Profissionais cadastrados</span>
            <span className="funcionarios-list__count">
              {funcionarios.length}
            </span>
          </div>

          <div className="funcionarios-list__items">
            {funcionarios.map((funcionario) => (
              <div
                key={funcionario.id}
                className="funcionarios-list__item"
              >
                <div className="funcionarios-list__avatar" aria-hidden="true">
                  {funcionario.nome?.charAt(0)?.toUpperCase() || "P"}
                </div>

                <span className="funcionarios-list__name">
                  {funcionario.nome}
                </span>

                <span
                  className="funcionarios-list__indicator"
                  aria-hidden="true"
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FuncionariosList;
